import type { ResponseGetRewardItem } from "@/../@types/fun-to-wait";

// fallback max points per day (minutes), used only if systemSetting.maxPointPerSession fails to load
export const MAX_POINTS_PER_SESSION = 80; // minutes
export const MAX_POINTS_PER_DAY = 0; // 0 means null
export const POINT_PER_MIN = 1;
export const SEC_TO_CANCEL = 18000;

// fallback feedback survey reward points, used only if systemSetting.feedbackPoint fails to load
export const FEEDBACK_POINT = 10;

// fallback for systemSetting.guestAllowExchange - defaults to permissive so a settings-fetch
// hiccup doesn't accidentally block exchange for everyone
export const GUEST_ALLOW_EXCHANGE = true;

// Points saving
export const POINTS_TABLE = "total_points";

export const CHECK_IN_OUT_TABLE = "check_in_out";
export interface LocalCheckInOut {
    placeIdHash: string;
    name: string;
    fromUnixtime?: number;
    toUnixtime?: number;
    points: number;
    status: "checkin" | "checkout";
}

// sessionStorage key marking a guest's just-exchanged ticket id, so a reload of its detail page
// (right after exchanging) still works, while direct/bookmarked/shared access to it does not -
// see the "tickets-owned-detail" route guard in router/index.ts
export const GUEST_OWNED_TICKET_ACCESS_KEY = "vacan/funtowait/guestOwnedTicketAccess";

// Points exchanged
export const OWNED_TICKETS_TABLE = "owned_tickets";
export type LocalOwnedTickets = ResponseGetRewardItem & {
    userRewardItemIdHash: string; // the actual IndexedDB primary key (OWNED_TICKETS_TABLE keyPath)
    exchangeUnixtime: number;
    usedUnixtime?: number;
    fromUnixtime?: number; // for owned-detail-item-card on reload
};
